export enum EDay {
  Monday = 'monday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday',
  Thursday = 'thursday',
  Friday = 'friday',
  Saturday = 'saturday',
  Sunday = 'sunday'
}

export const days = [
  EDay.Monday,
  EDay.Tuesday,
  EDay.Wednesday,
  EDay.Thursday,
  EDay.Friday,
  EDay.Saturday,
  EDay.Sunday
]
